// extracted by mini-css-extract-plugin
module.exports = {"locations":"_65b6daa2","content":"_f74108c5"};